<msf-summary-wrapper
  title="{{ 'Administration' | translate }}"
  [items]="items"
>
  <div right #right [style.padding]="'20px'">
    <app-electronic-field-map-summary class="summary-info"></app-electronic-field-map-summary>
  </div>
</msf-summary-wrapper>
